var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"actionActivator pick",class:{disablePickBtn: !_vm.isPermission},attrs:{"slot":"activator","disabled":!_vm.isPermission},on:{"click":_vm.pickChatRoom},slot:"activator"},[_vm._v("\n    受付\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fd3815c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/operation/fragments/chat_area/pick_chat_room.vue
// module id = null
// module chunks = 